import React, { ReactNode } from "react";
import { Box } from "@mui/material";
import { styles } from "./styles";
import Header from "../header";
import { useIsCountrySelected } from "../../hooks/useIsCountrySelected";

interface MainContainerProps {
  children?: ReactNode;
}

const MainContainer: React.FC<MainContainerProps> = ({ children }) => {
  return (
    <Box sx={styles.mainContainer}>
      <Header />
      <Box sx={styles.mainRightContainer}>{children}</Box>
    </Box>
  );
};

export default MainContainer;
